import { EventInput } from '@fullcalendar/core'
import { UserProductDTOFields } from '../Types/dto/user/product'
import { UserDTO } from '../Types/dto/user'

export function convertUserAdToEventInputs(
	userDTO: UserDTO | null,
	teamSlugUser: string | null,
	ad?: UserProductDTOFields,
	adSubPageFilterIds?: string[] | null,
	isOnlyUserBookingVisible?: Boolean
): EventInput[] {
	if (!ad) {
		return []
	}

	const events: EventInput[] = []
	for (const adSubPageId of Object.keys(ad.adSubPages ?? {})) {
		if (
			adSubPageFilterIds &&
			adSubPageFilterIds?.length > 0 &&
			!adSubPageFilterIds.includes(adSubPageId)
		) {
			continue
		}

		const eventColor = ad.adSubPages?.[adSubPageId]?.colorCode ?? 'black'
		const adSubPage = ad.adSubPages?.[adSubPageId]

		for (const [productBundleId, productBundle] of Object.entries(
			adSubPage?.productBundles ?? {}
		)) {
			for (const [
				externalGoogleCalendarId,
				externalGoogleCalendar,
			] of Object.entries(productBundle.externalGoogleCalendars ?? {})) {
				for (const [eventTimeId, eventTime] of Object.entries(
					externalGoogleCalendar.eventTimes ?? {}
				)) {
					if (!eventTime.startTime) {
						continue
					}
					const start = new Date(eventTime.startTime)
					const end = eventTime.endTime
						? new Date(eventTime.endTime)
						: undefined
					const extendedProps = {
						adSubPageId,
						userName: 'na',
					}
					if (!isOnlyUserBookingVisible) {
						events.push({
							isBasket: false,
							id: eventTimeId,
							title: 'foglalt',
							start,
							end,
							editable: false,
							extendedProps,
							color: eventColor,
							adSubPageId,
						})
					}
				}
			}
		}

		const tickets = ad?.tickets ?? []
		for (const ticket of tickets) {
			if (!ticket.startTime) {
				continue
			}
			const start = new Date(ticket.startTime)
			const end = ticket.endTime ? new Date(ticket.endTime) : undefined
			const extendedProps = {
				adSubPageId,
				userName: ticket.userName ?? 'na',
			}
			const b: boolean =
				teamSlugUser != undefined &&
				userDTO?.email != undefined &&
				ticket.userName == userDTO?.userName &&
				userDTO?.isTikexAdmin != undefined &&
				userDTO?.teams?.[teamSlugUser]?.usersWithPermission?.[userDTO?.email]
					?.range == 'all'

			if (!isOnlyUserBookingVisible || ticket.userName == userDTO?.userName) {
				events.push({
					isBasket: false,
					id: ticket._id,
					title: b ? ticket.userName : 'foglalt',
					start,
					end,
					editable: ticket.userName == userDTO?.userName,
					extendedProps,
					color: eventColor,
					adSubPageId: ticket.adSubPageId,
				})
			}
		}
	}

	return events
}

const getColor = (str: string): string => {
	const hash = str
		.split('')
		.reduce((acc, char) => (acc * 31 + char.charCodeAt(0)) % 16777215, 0)
	return '#' + hash.toString(16)
}
